module.exports = __webpack_public_path__ + "static/media/shops_services-min.a220e79c.jpg";